/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-wrap-multilines */
import { EditOutlined } from '@ant-design/icons';
import withAuthenticator from 'HOCs/withAuthenticator';
import { Button, Col, DatePicker, Form, Input, Row, Select, message } from 'antd';
import StudentContainer from 'components/Containers/StudentContainer';
import { hanhtrangsoClient } from 'configs/api';
import { checkAdminRole, studentsDemo, testTeachers } from 'constants/auth';
import { getWithoutModuleId, update } from 'helpers/QueryHelper';
import { login } from 'modules/Auth/actions';
import moment from 'moment';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import ChangePasswordPopup from 'modules/Administration/components/Users/components/ChangePasswordPopup';
import { classOptionsBySchoolTypeId } from 'constants/optionCommon';
import { genderOptions, schoolTypeOptions, studentSchoolTypeOptions } from './data';

export const getNameSplit = (fullName) => {
  const nameParts = fullName?.split(' ');
  const firstName = nameParts?.pop(); // Lấy phần cuối cùng làm tên
  const lastName = nameParts?.join(' '); // Phần còn lại là họ và tên đệm

  return {
    firstName,
    lastName,
  };
};

export default withAuthenticator(({ loggedInUser }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [isProcessing, setIsProcessing] = React.useState(false);
  const [selectedCityId, setSelectedCityId] = React.useState(loggedInUser?.cityId);
  const [openModal_password, setOpenModal_password] = useState({
    email: '',
    fullName: '',
  });

  const [selectedSchoolType, setSelectedSchoolType] = React.useState(loggedInUser?.schoolTypeId);

  const { data: cities } = useQuery('METADATA_Cities', () => getWithoutModuleId('Cities', 'id, code, name', {}, 'code asc', 'METADATA', 'SACHSO'), {
    retry: false,
  });

  // const { data: departments } = useQuery(['METADATA_Departments', selectedCityId], () => getWithoutModuleId('Departments', 'id, parentId, cityCode, name', { cityCode: selectedCityId }, 'name', 'METADATA', 'SACHSO'), {
  //   enabled: !!selectedCityId,
  //   retry: false,
  // });

  const isAdmin = checkAdminRole(loggedInUser);
  const isStudent = loggedInUser.role === 'student';
  const isTestTeacher = testTeachers.includes(loggedInUser.email);
  const isStudentDemo = studentsDemo.includes(loggedInUser.email.toLowerCase());
  const { firstName, lastName } = getNameSplit(loggedInUser.fullName);
  const birthDay = loggedInUser.birthday || loggedInUser.dateofBirth ? moment(loggedInUser.birthday ?? loggedInUser.dateofBirth) : null;
  const initialValues = {
    email: loggedInUser.email,
    birthday: birthDay,
    firstName,
    lastName,
    phoneNumber: loggedInUser.phone,
    // eslint-disable-next-line no-nested-ternary
    gender: loggedInUser.gender ?? (loggedInUser.sex === true ? 1 : loggedInUser.sex === false ? 2 : null),
    city: loggedInUser.city ?? loggedInUser.cityId,
    schoolTypeId: loggedInUser.schoolTypeId,
    school: loggedInUser.school ?? loggedInUser.schoolName,
    classId: loggedInUser.classId ?? loggedInUser.className,
    department: loggedInUser.departmentId,
  };

  // API update cuar sachso (ben minh softech)
  function sachsoUpdate(params) {
    // Tất cả các cột của bảng Users
    //     {
    //     "id": 2,
    //     "fullName": "Học sinh 1",
    //     "parentName": null,
    //     "email": "hs@gmail.com",
    //     "phone": "0905157888",
    //     "code": "ED4A5E3B-F4F6-481C-8B84-B59CAA59C00C",
    //     "sex": true,
    //     "userName": "hs@gmail.com",
    //     "password": "e40f01afbb1b9ae3dd6747ced5bca532",
    //     "cityId": null,
    //     "districtId": null,
    //     "schoolId": 17715,
    //     "roles": [
    //         {
    //             "id": 1,
    //             "name": "Student"
    //         }
    //     ],
    //     "pronunciationLevel": "Interactive",
    //     "note": null,
    //     "groupId": 1,
    //     "className": "",
    //     "avatar": null,
    //     "profile": null,
    //     "verifyCode": null,
    //     "verifyCount": 0,
    //     "forgotPasswordCount": 0,
    //     "activationCodeFailedLeft": 0,
    //     "referrer": "https://sachso.edu.vn",
    //     "speechRecognitionAPI": "AZURE",
    //     "lastActivity": "2019-03-08T16:40:52.517",
    //     "status": "ACTIVE",
    //     "createdDate": "2019-03-08T16:40:52.517",
    //     "createdBy": "hs@gmail.com",
    //     "modifiedDate": "2019-03-08T16:40:52.517",
    //     "modifiedBy": 2,
    //     "currentCredit": 5,
    //     "dateofBirth": null,
    //     "schoolTypeId": null,
    //     "rowId": "8c622eaa-2e14-41d2-8213-8bf5ececb418",
    //     "syncStatus": null,
    //     "departmentId": null
    // }
    return new Promise((resolve, reject) => {
      update('Users', loggedInUser?.id, params, '', 'AMES247')
        .then((response) => {
          // console.log('📦 Response update:', response);

          if (response?.rowsAffected > 0) {
            resolve();
            dispatch(login(loggedInUser.email, loggedInUser.password));
          } else {
            reject(new Error('Lỗi: Không có dòng nào được cập nhật'));
          }
        })
        .catch((error) => {
          // console.error('❌ API update error:', error);
          reject(new Error('Lỗi: không thể gọi API'));
        });
    });
  }

  // API update cuar hanhtrangso (API này đã bị bỏ ko dùng nữa)
  // function hanhtrangsoUpdate(values) {
  //   return new Promise((resolve, reject) => {
  //     hanhtrangsoClient
  //       .post('/Home/UpdateUserInfo', values, { headers: { Authorization: `Bearer ${loggedInUser?.accessToken}` } })
  //       .then((response) => {
  //         if (response.data.status === 'success') {
  //           resolve();
  //         } else {
  //           reject(new Error('Lỗi'));
  //         }
  //       })
  //       .catch((error) => {
  //         reject(new Error('Lỗi'));
  //       });
  //   });
  // }

  const onFinish = (values) => {
    // cập nhật song song 2 API , trường hợp API của hanhtrangso bị lỗi dẫn đến dữ liệu bên mình bị ghi đè sau đăng nhập thì chấp nhận (sau này có thay đổi thì confirm lại anh Bình vfa anh Hùng)
    // Promise.any([
    sachsoUpdate({
      fullName: `${values.lastName} ${values.firstName}`,
      phone: values.phoneNumber,
      sex: values.gender === 1 ? 1 : 0,
      dateofBirth: moment(values.birthday).format('YYYY-MM-DD'),
      schoolTypeId: values.schoolTypeId ?? loggedInUser.schoolTypeId ?? 0,
      cityId: values.city,
      departmentId: values.department, // param này có từ trước ("Phòng giáo dục")
      schoolName: values.school,
      classId: values.classId,
    })
      // hanhtrangsoUpdate(values), API này bỏ đi ko dùng nữa
      // ])
      .then(() => {
        message.success('Cập nhật thành công !');
      })
      .catch((error) => {
        message.error('Có lỗi xảy ra trong quá trình cập nhật!');
      });

    // Logic mới 04/10/2023, cập nhật dữ liệu cho bên mình (server.sachso.edu.vn) trước, còn bên hanhtrangsoClient được hay không thì không phụ thuộc

    // Logic cũ: cập nhật dữ liệu bên hanhtrangsoClient thành công mới cập nhật bên mình (server.sachso.edu.vn)
    // hanhtrangsoClient
    //   .post('/Home/UpdateUserInfo', values, { headers: { Authorization: `Bearer ${loggedInUser?.accessToken}` } })
    //   .then((response) => {
    //     if (response.data.status === 'success') {
    //       message.success('Cập nhật thành công !');
    //       // sachsoUpdate
    //       update('Users', loggedInUser?.id, { departmentId: values.department }, '', 'AMES247').then(() => {
    //         dispatch(login(loggedInUser.email, loggedInUser.password));
    //       });
    //     } else {
    //       message.error('Có lỗi xảy ra trong quá trình cập nhật!');
    //     }
    //   })
    //   .catch((error) => {
    //     console.log('🚀', error);
    //     message.error('Có lỗi xảy ra trong quá trình cập nhật!');
    //   });
  };

  const onValuesChange = (changedValues, allValues) => {
    // changedValues chỉ chứa giá trị của field thay đổi;
    const { firstName, lastName, phoneNumber, gender, birthday, schoolTypeId, city, department, school, classId } = changedValues;
    if (city !== undefined) {
      form.setFieldsValue({
        department: city === Number(loggedInUser.city) ? loggedInUser.departmentId : null,
      });
      setSelectedCityId(city);
    }
  };

  return (
    <React.Fragment>
      <Form form={form} name='update-profile' onFinish={onFinish} layout='vertical' initialValues={initialValues} requiredMark={false} onValuesChange={onValuesChange}>
        <Card>
          <CardHeader>
            <h3 className='mb-0'>TRANG CÁ NHÂN</h3>
          </CardHeader>
          <CardBody>
            <h6 className='heading-small text-muted mb-4'>Thông tin người dùng</h6>
            <Row gutter={[24, 0]}>
              <Col xs={24} sm={12}>
                <Form.Item name='email' label='Email (dùng để đăng nhập)'>
                  <Input disabled size='large' />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item name='phoneNumber' label='Số điện thoại' hasFeedback rules={[{ len: 10, message: 'Số điện thoại không hợp lệ' }]}>
                  <Input size='large' />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item name='lastName' label='Họ và tên đệm' rules={[{ whitespace: true, required: true, message: 'Chưa nhập Họ và tên đệm' }]}>
                  <Input size='large' />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item name='firstName' label='Tên' rules={[{ whitespace: true, required: true, message: 'Chưa nhập Tên' }]}>
                  <Input size='large' />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item name='gender' label='Giới tính' rules={[{ required: true, message: 'Chưa nhập Giới tính' }]}>
                  <Select placeholder='Chọn giới tính' options={genderOptions} size='large' />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item name='birthday' label='Ngày sinh' rules={[{ required: true, message: 'Chưa nhập Ngày sinh' }]}>
                  <DatePicker format='DD/MM/YYYY' style={{ width: '100%' }} size='large' />
                </Form.Item>
              </Col>
              {/* </Row>

            <hr className='my-4' />
            <h6 className='heading-small text-muted mb-4'>Thông tin liên lạc</h6>

            <Row gutter={[24, 24]} align={'bottom'}> */}
              {/* <Col xs={24} sm={12}>
                <Form.Item name='city' label='Sở giáo dục (Tỉnh / Thành phố TW)' rules={[{ required: true, message: 'Chưa nhập Sở giáo dục' }]}>
                  <Select
                    showSearch
                    placeholder='Chọn sở giáo dục'
                    options={cities ?? []}
                    size='large'
                    fieldNames={{ value: 'code', label: 'name' }}
                    allowClear
                    filterOption={(input, option) => option?.name?.toLowerCase()?.includes(input?.toLocaleLowerCase() ?? '')}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item name='department' label='Phòng giáo dục (Thành phố / Quận / Huyện / Thị Xã)' rules={[{ required: true, message: 'Chưa nhập Phòng giáo dục' }]}>
                  <Select
                    placeholder='Chọn phòng giáo dục'
                    options={departments ?? []}
                    size='large'
                    fieldNames={{ value: 'id', label: 'name' }}
                    allowClear
                    filterOption={(input, option) => option?.name?.toLowerCase()?.includes(input?.toLocaleLowerCase() ?? '')}
                    showSearch
                  />
                </Form.Item>
              </Col> */}
              <Col xs={24} sm={12}>
                <Form.Item name='school' label='Trường học' rules={[{ required: true, message: 'Chưa nhập Trường học' }]}>
                  <Input size='large' />
                  {/* <Select size='large' options={schools ?? []} fieldNames={{ value: 'id', label: 'name' }} allowClear filterOption={(input, option) => option?.name?.toLowerCase()?.includes(input?.toLocaleLowerCase() ?? '')} showSearch /> */}
                </Form.Item>
              </Col>
              {!isStudent || isAdmin ? (
                <Col xs={24} sm={12}>
                  <Form.Item name='schoolTypeId' label='Cấp dạy'>
                    <Select placeholder='Chọn cấp dạy' options={schoolTypeOptions} size='large' />
                  </Form.Item>
                </Col>
              ) : (
                <>
                  <Col xs={24} sm={12}>
                    <Form.Item name='schoolTypeId' label='Cấp học' rules={[{ required: true, message: 'Chưa nhập Cấp học' }]}>
                      <Select placeholder='Chọn cấp học' value={selectedSchoolType} onChange={(value) => setSelectedSchoolType(value)} options={studentSchoolTypeOptions} size='large' />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <StudentContainer>
                      <Form.Item name='classId' label='Lớp học' rules={[{ required: true, message: 'Chưa nhập Lớp học' }]}>
                        <Select placeholder='Chọn lớp' options={classOptionsBySchoolTypeId(selectedSchoolType)} size='large' />
                      </Form.Item>
                    </StudentContainer>
                  </Col>
                </>
              )}
            </Row>
          </CardBody>
          {!isTestTeacher && (
            <CardFooter>
              <Button type='primary' htmlType='submit' icon={<EditOutlined />} disabled={isStudentDemo}>
                Cập nhật
              </Button>
              <Button style={{ marginLeft: 10 }} type='primary' onClick={() => setOpenModal_password({ email: loggedInUser?.email, fullName: loggedInUser?.fullName })} icon={<EditOutlined />} disabled={isStudentDemo}>
                Đổi mật khẩu
              </Button>
            </CardFooter>
          )}
          {/* <CardFooter>
            <Button type='primary' htmlType='submit' icon={<EditOutlined />} loading={isProcessing}>
              Cập nhật
            </Button>
            {!isTestTeacher && !isStudentDemo && (
              <Button style={{ marginLeft: 10 }} type='primary' onClick={() => setOpenModal_password({ email: loggedInUser?.email, fullName: loggedInUser?.fullName })} icon={<EditOutlined />} disabled={isProcessing}>
                Đổi mật khẩu
              </Button>
            )}
          </CardFooter> */}
        </Card>
      </Form>
      <ChangePasswordPopup userInfor={openModal_password} onSuccess={() => {}} />
    </React.Fragment>
  );
});
